export const PSP_PERMISSIONS_PRIORITIES: Record<string, number> = {
  FEATURE_ADMIN_MASTER_DATA: 1,
  FEATURE_ADMIN_PRICE_LIST: 3,
  FEATURE_ADMIN_BRANCHES: 4,
  FEATURE_ADMIN_DOCUMENTS: 5,
  FEATURE_ADMIN_PROFILES: 6,
  FEATURE_ADMIN_USERS: 2,
  FEATURE_ADMIN_ASSIGNMENTS: 7,
  FEATURE_SIGN_CONTRACT: 9,
  FEATURE_ADMIN_ASSIGNMENT_DATES: 10,
  FEATURE_CREATE_ASSIGNMENTS: 8,
};

export const CUSTOMER_PERMISSIONS_PRIORITIES: Record<string, number> = {
  FEATURE_PUBLISH_INQUIRY: 1,
  FEATURE_CLOSE_INQUIRY: 2,
  FEATURE_ACCEPT_OFFER: 3,
  FEATURE_PRESELECT_OFFERS: 4,
  FEATURE_ADMIN_WORK_COUNCIL_COMMUNICATION: 5,
  FEATURE_ADMIN_ASSIGNMENTS: 6,
  FEATURE_SIGN_CONTRACT: 7,
  FEATURE_ADMIN_ASSIGNMENT_DATES: 8,
};
